import collect from 'collect.js';

export default function str(value: string) {
  return new Stringable(value);
}

export class Stringable {
  private value: string;

  public constructor(value: string) {
    this.value = value;
  }

  public start(prefix: string): this {
    if (!this.value) {
      return this;
    }

    if (this.value.startsWith(prefix)) {
      return this;
    }

    this.value = `${prefix}${this.value}`;

    return this;
  }

  public squish(): this {
    this.value = this.value.replace(/\s+/g, ' ').trim();

    return this;
  }

  public replace(search: string | RegExp, replace: string): this {
    this.value = this.value.replace(search, replace);

    return this;
  }

  public replaceAll(values: { [key: string]: string }): this {
    Object.keys(values).map((key) => {
      this.replace(key, values[key]);
    });

    return this;
  }

  public trim(): this {
    this.value = this.value.trim();

    return this;
  }

  public padLeft(length: number, pad: string = ' '): this {
    const diff = length - this.value.length;

    if (diff <= 0) {
      return this;
    }

    this.value =
      collect()
        .times(diff, () => pad)
        .implode('') + this.value;

    return this;
  }

  public ucfirst(): this {
    this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1);

    return this;
  }

  public headline(): this {
    const ucsplit = (value: string): string[] => {
      return value
        .replace(/([a-z])([A-Z])/g, '$1 $2') // camelCase -> camel Case
        .split(/[\s_-]+/); // split by space, underscore, or dash
    };

    let parts = this.value.split(' ');

    if (parts.length === 1) {
      parts = ucsplit(this.value);
    } else {
      parts = parts.flatMap(ucsplit);
    }

    parts = parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());

    const collapsed = parts.join('_').replace(/[-_ ]+/g, '_');

    this.value = collapsed.split('_').filter(Boolean).join(' ');

    return this;
  }

  public lower(): this {
    this.value = this.value.toLowerCase();

    return this;
  }

  public capitalize(): this {
    this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1);

    return this;
  }

  public toString(): string {
    return this.value;
  }

  public valueOf(): string {
    return this.value;
  }

  public static toHuman(value: string): string {
    return str(value).headline().lower().ucfirst().toString();
  }
}
